import Notification from '../notification';
import WapiForecastSettings from './WapiForecastSettings.js';
import WapiLimitSettings from './WapiLimitSettings.js';
import WapiReanalysisSettings from './WapiReanalysisSettings.js';
import WapiPresetSettings from './WapiPresetSettings.js';

/**
 * WapiContract
 */
export default class WapiContract {
  constructor() {
    this.id = '';
    this.user_id = '';
    this.forecast_settings = new WapiForecastSettings();
    this.reanalysis_settings = new WapiReanalysisSettings();
    this.name = '';
    this.status = 1;
    this.up_time = new Date().toISOString().substr(0, 10),
      this.create_date = new Date().toISOString().substr(0, 10),
      this.expiration_date = new Date().toISOString().substr(0, 10),
      this.notification_settings = new Notification();
    this.limit_settings = new WapiLimitSettings();
    this.preset_settings = new WapiPresetSettings();
  }
}
